import FreespinRecord from 'slotworks/model/gameplay/records/freespin-record';

export default class FreeSpinsRecord extends FreespinRecord {
    totalWinCash: number;
    triggering_game: string;
    next_game: string;
    total: number;
    recover: boolean;
    bonusPayoff: number;
    freeSpinPayoff: number;
    scatterPayoff: number;
    parentBonusGameState: any;
}



// WEBPACK FOOTER //
// ./src/integration/freespin-record.ts